
  import ClientCore from "../../../models/core/ClientCore";
  import ProjectCore from "../../../models/core/ProjectCore";
  import ProjectCardMedia from "../../view_elements/ProjectCardMedia.vue";

  export default {
    name: "ProjectClientRow",
    components: { ProjectCardMedia },
    props: {
      client: ClientCore,
      clientProjects: Array<ProjectCore>,
      shouldBeCollapsable: Boolean
    },
    data() {
      return {
        showCollapse: true
      };
    },
    methods: {
      collapse() {
        this.showCollapse = true;
      }
    }
  };
